<div class="billing_overlay">
  <div class="billing_row">
    <span class="billing_back" (click)="onGoToBilling()">« Back to Hygger</span>
  </div>
	<router-outlet></router-outlet>
</div>
